﻿

(function ($, document, undefined) {
    $(document).ready(function () {
        $(document).on('click', '[data-toggle-active]', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $panel = $($this.data('toggle-active'));
            if ($panel.data('toggle-status') == 'active') {
                $panel.data('toggle-status', 'inactive')
                    .attr('data-toggle-status', 'inactive')
                ;
            } else {
                $panel.data('toggle-status', 'active')
                    .attr('data-toggle-status', 'active')
                ;
            }
        });
    });
})(jQuery, document);